import { configureStore } from '@reduxjs/toolkit';
import notifierReducer from './reducers/notifierReducer';

export const store = configureStore({
    reducer: {
        notifier: notifierReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
